import { fromPromise } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { find, isEmpty, isNil, map } from 'lodash'

// For more details on the implementation please see https://able.bio/AnasT/apollo-graphql-async-access-token-refresh--470t1c8

let isRefreshing = false
let pendingRequests = []

const setIsRefreshing = value => {
  isRefreshing = value
}

const addPendingRequest = pendingRequest => {
  pendingRequests.push(pendingRequest)
}

const resolvePendingRequests = () => {
  map(pendingRequests, callback => callback())
  pendingRequests = []
}

const createRefreshTokenApolloErrorLink = getNewAccessToken =>
  onError(({ graphQLErrors, operation, forward }) => {
    if (!isEmpty(graphQLErrors)) {
      const unauthenticatedError = find(
        graphQLErrors,
        error => error.extensions.code === 'UNAUTHENTICATED',
      )

      if (!isNil(unauthenticatedError)) {
        let requestsToForward

        // we only want to ask for a new token on the first failed request,
        // for the others we add them to a list of pending requests
        if (!isRefreshing) {
          setIsRefreshing(true)

          requestsToForward = fromPromise(
            getNewAccessToken()
              .then(() => {
                resolvePendingRequests()
              })
              .catch(() => {
                pendingRequests = []
              })
              .finally(() => {
                setIsRefreshing(false)
              }),
          )
        } else {
          requestsToForward = fromPromise(
            new Promise(resolve => {
              addPendingRequest(() => resolve())
            }),
          )
        }

        return requestsToForward.flatMap(() => forward(operation))
      }
    }
    return null
  })

export default createRefreshTokenApolloErrorLink
